<template>
  <el-form
    v-loading="loading"
    ref="ruleFormRef"
    :model="ruleForm"
    :rules="rules"
    label-width="90px"
    class="demo-ruleForm scroll_y"
    size="large"
    scroll-to-error
    :scroll-into-view-options="{behavior:'smooth'}"
    status-icon
  >
    <el-form-item label="院校名称" prop="name">
      <el-input
        v-model="ruleForm.name"
        placeholder="请填写院校名称"
        class="big_input"
      />
    </el-form-item>
    <el-row>
      <el-col :span="12"
        ><el-form-item label="院校类型" prop="category">
          <el-select
            v-model="ruleForm.category"
            class="m-2 small_input"
            placeholder="请选择院校类型"
            @change="searchData"
          >
            <el-option
              v-for="item in this.$constGlobal.schoolType"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select> </el-form-item
      ></el-col>
      <el-col :span="12">
        <el-form-item label="排序权重" prop="orderIndex">
          <el-tooltip
            class="item"
            effect="dark"
            content="只能输入数字（整数）且必须大于0"
            placement="top"
          >
            <el-input
              class="small_input"
              type="number"
              v-model="ruleForm.orderIndex"
              placeholder="大于0的整数"
            />
          </el-tooltip> </el-form-item
      ></el-col>
    </el-row>

    <el-form-item label="关键字设置" prop="keywords">
      <el-col :span="24">
        <el-tag
          v-for="(item, index) in ruleForm.keywords"
          :key="item"
          closable
          @close="delKeyword(index, ruleForm.keywords)"
        >
          {{ item }}
        </el-tag>
      </el-col>
      <el-col v-if="ruleForm.keywords.length !== 5">
        <el-input
          class="small_input"
          v-model="keyword"
          placeholder="2-8字"
          maxlength="8"
          clearable
        ></el-input>
        <el-button
          v-if="ruleForm.keywords.length !== 5"
          type="primary"
          @click="addKeyword(keyword, ruleForm.keywords)"
          plain
        >
          <el-icon> <Plus /> </el-icon>&nbsp;添加
        </el-button>
      </el-col>
    </el-form-item>
    <el-form-item label="联系电话" prop="tel">
      <el-input
        v-model="ruleForm.tel"
        placeholder="请填写联系电话"
        class="small_input"
      />
    </el-form-item>

    <el-row>
      <el-col :span="12">
        <el-form-item label="院校性质" prop="nature">
          <el-input
            v-model="ruleForm.nature"
            placeholder="请填写院校性质"
            class="big_input"
          />
        </el-form-item>
        
      </el-col>
      <el-col :span="12">
        <el-form-item label="院校类别" prop="schoolType">
          <el-input
            v-model="ruleForm.schoolType"
            placeholder="请填写院校类别"
            class="big_input"
          />
        </el-form-item></el-col>
    </el-row>

    <el-form-item label="院校地址" prop="address">
      <el-input
        v-model="ruleForm.address"
        placeholder="请填写院校地址"
        class="big_input"
      />
    </el-form-item>
    <el-form-item label="院校特色" prop="characteristic">
      <el-input
        v-model="ruleForm.characteristic"
        placeholder="请填写院校特色"
        :rows="3"
        type="textarea"
        class="big_input"
      />
    </el-form-item>
    <el-form-item label="院校图片" prop="logoPath">
      <ImgUpload
        v-if="childShow"
        :type="3"
        :limit="1"
        ref="addEditImgRef"
        :imagePath="ruleForm.logoPath"
        @change-image="changeImage"
      ></ImgUpload>
    </el-form-item>
    <el-form-item label="院校内容" prop="contents">
      <WangEditor
        :isDecode="false"
        ref="summary"
        v-if="childShow"
        :content="ruleForm.contents"
        @changeContent="changeContent"
      />
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" size="large" @click="submitForm(ruleFormRef)" v-if="!submitDisabled" :disabled = "submitDisabled"
      >提交保存</el-button
    >
    <el-button type="primary" size="large" loading v-else>提交中</el-button>
  </div>
</template>

<script>
import {
  getSchoolDetails,
  addSchool,
  modifySchool,
} from "network/schoolManagement.js";
import WangEditor from "components/wangEditor/WangEditor.vue";
import ImgUpload from "components/ImgUpload.vue";
import { toRefs, reactive, ref, unref, onMounted } from "vue";
import { ElMessage, ElMessageBox, Loading } from "element-plus";
import { textFilter, isEditorNull } from "common/utils.js";
export default {
  name: "AddEditSchool",
  components: {
    WangEditor,
    ImgUpload,
  },
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editId: Number,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const addEditImgRef = ref();
    const data = reactive({
      loading: false,
      childShow: false,
      ruleForm: {
        name: "",
        category: "",
        orderIndex: null,
        keywords: [],
        tel: null,
        address: null,
        logoPath: "",
        contents: "",
        nature:'',//院校性质
        schoolType:'',//院校类别
        characteristic:'',//院校特色
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写院校名称",
            trigger: "blur",
          },
        ],
        category: [
          {
            required: true,
            message: "请选择院校类型",
            trigger: "change",
          },
        ],
        logoPath: [
          {
            required: true,
            message: "请选择院校图片",
            trigger: "blur",
          },
        ],
        orderIndex: [
          {
            required: true,
            message: "请填写排序权重",
            trigger: "blur",
          },
        ],
        nature: [
          {
            required: true,
            message: "请填写院校性质",
            trigger: "blur",
          },
        ],
        schoolType: [
          {
            required: true,
            message: "请填写院校类别",
            trigger: "blur",
          },
        ],
        characteristic: [
          {
            required: true,
            message: "请填写院校特色",
            trigger: "blur",
          },
        ],
        contents: [
          {
            required: true,
            message: "请填写院校内容",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              let isEmpty = isEditorNull(textFilter(value));
              if (isEmpty) {
                callback(new Error("请填写院校内容"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      keyword: [],
      submitDisabled:false
    });
    onMounted(() => {
      //编辑请求院校详情
      if (props.editId > 0) {
        data.loading = true;
        getSchoolDetails(props.editId)
          .then((result) => {
            if (result && result.code == 1) {
              data.loading = false;
              data.childShow = true;
              data.ruleForm = result.result;
            } else {
              data.loading = false;
              ElMessage.error(result.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        data.childShow = true;
      }
    });

    //添加关键字或标签:isTag是否是标签主要用于清除输入框内容
    const addKeyword = (val, valAll) => {
      if (val == "" || val == null || val.length < 2) {
        ElMessage.error("请输入2-8个字");
        return false;
      }
      if (valAll.length >= 5) {
        data.keyword = "";
        ElMessage.error("最多只能设置5个");
        return false;
      }
      var index = valAll.indexOf(val);
      if (index >= 0) {
        ElMessage.error("关键字[" + val + "]已存在");
        return false;
      }
      valAll.push(val);
      data.ruleForm.keywords = valAll;
      ElMessage({ message: "添加成功！", type: "success" });
      data.keyword = "";
    };
    //删除关键字或标签
    const delKeyword = (index, valAll) => {
      valAll.splice(index, 1);
      ElMessage({ message: "删除成功！", type: "success" });
    };
    //获取图片上传组件传过来的
    const changeImage = (arr) => {
      if (arr && arr.length > 0) {
        data.ruleForm.logoPath = arr[0].url;
        ruleFormRef.value.clearValidate("logoPath");
      } else {
        data.ruleForm.logoPath = "";
      }
    };
    //获取富文本编辑器传过来的
    const changeContent = (val) => {
      if (val) {
        // data.ruleForm.contents = encodeURIComponent(val);
        data.ruleForm.contents =val;
        ruleFormRef.value.clearValidate("contents"); //移除校验结果
      } else {
        data.ruleForm.contents = "";
      }
    };

    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          this.$refs['ruleFormRef'].validate((valid) => {
            if (!valid) {
              setTimeout(() => {
                document.getElementsByClassName('is-error')[0].scrollIntoView({ behavior: 'smooth' })
              }, 0)
            }
          })
          return false;
        } else {
          data.submitDisabled = true;
          updataAdd(data.ruleForm).then(() => {
            data.submitDisabled = false;
          });
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
      }
    };
    async function updataAdd(data) {
      data.loading = true;
      let result = "";
      if (props.editId > 0) {
        const editdata = {
          id: data.id,
          name: data.name,
          category: data.category,
          keywords: data.keywords,
          contents: data.contents,
          logoPath: data.logoPath,
          orderIndex: data.orderIndex,
          tel: data.tel,
          address: data.address,
          nature: data.nature,
          schoolType: data.schoolType,
          characteristic: data.characteristic,
        };
        result = await modifySchool(editdata);
      } else {
        result = await addSchool(data);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
        });
        if (addEditImgRef.value) {
          if (props.editId > 0) {
         const editdata = {
              id: data.id,
              name: data.name,
              category: data.category,
              keywords: data.keywords,
              contents: data.contents,
              logoPath: data.logoPath,
              orderIndex: data.orderIndex,
              tel: data.tel,
              address: data.address,
            };
            addEditImgRef.value.submitData(editdata.logoPath);
          } else {
            addEditImgRef.value.submitData(data.logoPath);
          }
        }
        emit("close-dialog");
        emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
              });
      }
    }

    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
      // 关闭弹窗 判断图片删除
      if (addEditImgRef.value) {
        addEditImgRef.value.cancelData();
      }
    };
    return {
      ...toRefs(data),
      ruleFormRef,
      addEditImgRef,
      changeImage,
      changeContent,
      addKeyword,
      delKeyword,
      submitForm,
      resetForm,
    };
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 540px;
}

</style>

